var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mm-table',{attrs:{"res":_vm.res}},[_c('el-table-column',{attrs:{"label":"EN","prop":"en_name"}}),_c('el-table-column',{attrs:{"label":"CN","prop":"cn_name"}}),_c('el-table-column',{attrs:{"label":"Code","prop":"code"}}),_c('el-table-column',{attrs:{"label":"Time Zone","prop":"time_zone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }